var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    {
      staticStyle: {
        position: "absolute",
        top: ".75em",
        left: ".75em",
        "z-index": "5"
      }
    },
    [
      _vm.visible
        ? _c("Settings", {
            attrs: {
              dateFrom: _vm.dateFrom,
              dateTo: _vm.dateTo,
              dateCurrent: _vm.dateCurrent
            },
            on: {
              "update:dateFrom": function($event) {
                return _vm.$emit("update:dateFrom", $event)
              },
              "update:dateTo": function($event) {
                return _vm.$emit("update:dateTo", $event)
              },
              "update:dateCurrent": function($event) {
                return _vm.$emit("update:dateCurrent", $event)
              }
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }